import React from "react";
import styled from "styled-components";
import { ButtonBase, Card as MuiCard } from "@material-ui/core";

// TODO: Setup Theme to control colors, etc
// ButtonCardBase uses the MUI ButtonBase for a better user experience on mobile and
// so when the card is pressed or clicked on, it uses the material design ripple
// animation.
const ButtonCardBase = styled(ButtonBase)<{ backgroundcolor?: string }>`
  width: 100%;
  text-align: left;
  margin-bottom: 16px;
  border-radius: 4px;

  .MuiPaper-root {
    min-height: 88px;
    background-color: ${props => props.backgroundcolor ?? "#fff"};
  }
`;

// CardBase is for when there is no onClick prop.
const CardBase = styled(MuiCard)<{ backgroundcolor?: string }>`
  width: 100%;
  text-align: left;
  margin-bottom: 16px;
  border-radius: 4px;

  .MuiPaper-root {
    min-height: 88px;
    background-color: ${props => props.backgroundcolor ?? "#fff"};
  }
`;

const CardContent = styled(MuiCard)`
  width: 100%;
  padding: 8px;
`;

interface Props {
  onClick?: () => void;
  eventClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  backgroundcolor?: string;
  "data-cy"?: string;
}

// TODO: This component should be named just card base, because depending on whether or not it has
// an onClick prop, it is not touchable.
const TouchableCardBase: React.FC<Props> = ({
  children,
  onClick,
  eventClick,
  backgroundcolor,
  ...rest
}: React.PropsWithChildren<Props>) => {
  return onClick || eventClick ? (
    <ButtonCardBase
      onClick={onClick ?? eventClick}
      backgroundcolor={backgroundcolor}
      data-cy={rest["data-cy"]}
    >
      <CardContent>{children}</CardContent>
    </ButtonCardBase>
  ) : (
    <CardBase backgroundcolor={backgroundcolor} data-cy={rest["data-cy"]}>
      <CardContent>{children}</CardContent>
    </CardBase>
  );
};

export default TouchableCardBase;
